/* Plastics Co navigation (pcon-*).
   Desktop: mega panels with hover intent (short open delay, quick switching between
   items, a grace period on leave), first-tap-opens on touch screens, and keyboard
   support (Down/Space opens, Esc closes, Left/Right moves between items).
   Everywhere: live product search from Shopify's predictive search, scoped to the
   category being browsed. Mobile: sizes the menu to the screen. */
(function () {
  if (window.PCON) return;
  window.PCON = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  /* "Natural Acetal Rod - 5mm to 75mm" -> "Natural Acetal Rod" */
  function shortTitle(t) { return String(t).replace(/ [–—|] /g, ' - ').split(' - ')[0]; }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Desktop mega menu ---------- */
  function initDesktop(nav) {
    var items = [].slice.call(nav.querySelectorAll('[data-pcon-item]'));
    var tops = [].slice.call(nav.querySelectorAll('.pcon__top'));
    var scrim = nav.querySelector('[data-pcon-scrim]');
    var current = null, openTimer = null, closeTimer = null;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function placeScrim() {
      nav.style.setProperty('--pcon-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
    }
    function open(item) {
      clearTimeout(closeTimer);
      if (current === item) return;
      if (current) shut(current, true);
      current = item;
      placeScrim();
      item.classList.add('is-open');
      item.querySelector('[data-pcon-top]').setAttribute('aria-expanded', 'true');
      item.querySelector('[data-pcon-panel]').hidden = false;
      scrim.hidden = false;
    }
    function shut(item, switching) {
      item.classList.remove('is-open');
      item.querySelector('[data-pcon-top]').setAttribute('aria-expanded', 'false');
      item.querySelector('[data-pcon-panel]').hidden = true;
      if (current === item) current = null;
      if (!switching) scrim.hidden = true;
    }
    function closeAll() { clearTimeout(openTimer); if (current) shut(current); }

    items.forEach(function (item) {
      var top = item.querySelector('[data-pcon-top]');
      var panel = item.querySelector('[data-pcon-panel]');

      item.addEventListener('mouseenter', function () {
        if (!canHover) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        /* Wait a beat so sweeping the cursor across the bar doesn't flash panels open.
           When a panel is already open the wait is shorter, but still long enough that
           cutting diagonally across a neighbouring item into the panel doesn't switch. */
        openTimer = setTimeout(function () { open(item); }, current ? 80 : 110);
      });
      item.addEventListener('mouseleave', function () { clearTimeout(openTimer); });

      /* Touch screens: first tap opens the panel, a second tap follows the link */
      top.addEventListener('click', function (e) {
        if (canHover) return;
        if (current !== item) { e.preventDefault(); open(item); }
      });

      top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          open(item);
          var first = panel.querySelector('a, input');
          if (first) first.focus();
        } else if (e.key === 'Escape') {
          closeAll();
        }
      });

      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeAll(); top.focus(); }
      });
    });

    /* Plain links in the bar (Best Sellers, Get a Quote) close whatever is open */
    [].forEach.call(nav.querySelectorAll('.pcon__item:not([data-pcon-item])'), function (item) {
      item.addEventListener('mouseenter', function () {
        if (!canHover) return;
        clearTimeout(openTimer);
        openTimer = setTimeout(closeAll, 80);
      });
      item.addEventListener('mouseleave', function () { clearTimeout(openTimer); });
    });

    /* Left/Right across the bar */
    tops.forEach(function (top, i) {
      top.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = tops[(i + d + tops.length) % tops.length];
        if (current) closeAll();
        next.focus();
      });
    });

    nav.addEventListener('mouseleave', function () {
      if (!canHover) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeAll, 260);
    });
    nav.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    scrim.addEventListener('click', closeAll);
    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) closeAll();
    });
    document.addEventListener('click', function (e) { if (current && !nav.contains(e.target)) closeAll(); });
    window.addEventListener('scroll', function () { if (current) placeScrim(); }, { passive: true });
    window.addEventListener('resize', function () { if (current) placeScrim(); });
  }

  /* ---------- Live search (desktop panels and mobile menu) ---------- */
  var cache = {};
  function initSearch(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var input = form.querySelector('input[type="search"]');
    var scope = form.getAttribute('data-scope') || '';
    var live = form.closest('[data-pcon-live]');
    var results = live.querySelector('[data-pcon-results]');
    var fallback = live.querySelector('[data-pcon-default]');
    var timer = null, ctrl = null, unscoped = false;

    /* Rods panel: "acetal 30mm" searches "acetal 30mm rod" (unless that finds nothing
       and the plain words do, in which case the plain words are used) */
    function query() {
      var v = input.value.trim();
      if (v && scope && !unscoped && v.toLowerCase().indexOf(scope) === -1) v += ' ' + scope;
      return v;
    }
    function empty(res) { return !(res.products || []).length && !(res.collections || []).length; }
    function show(on) { results.hidden = !on; if (fallback) fallback.hidden = on; }

    function render(res, raw) {
      var html = '';
      (res.collections || []).slice(0, 2).forEach(function (c) {
        html += '<a class="pcon-res pcon-res--col" href="' + esc(c.url) + '"><span class="pcon-res__ph">' +
          '<svg class="pcon-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h10"/></svg></span>' +
          '<span class="pcon-res__tx"><span class="pcon-res__k">Category</span><span class="pcon-res__t">' + esc(c.title) + '</span></span></a>';
      });
      (res.products || []).forEach(function (p) {
        var min = parseFloat(p.price_min || p.price), max = parseFloat(p.price_max || p.price);
        var price = isNaN(min) ? '' : (max > min ? 'From ' : '') + fmt.format(min);
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        html += '<a class="pcon-res" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="pcon-res__ph"></span>') +
          '<span class="pcon-res__tx"><span class="pcon-res__t">' + esc(shortTitle(p.title)) + '</span>' +
          (price ? '<span class="pcon-res__p">' + price + '</span>' : '') + '</span></a>';
      });
      if (html) {
        html += '<button type="submit" class="pcon-res__all" form="' + form.id + '">See all results for “' + esc(raw) + '”</button>';
      } else {
        html = '<p class="pcon-res__none">No matches for “' + esc(raw) + '”. We cut to order, so <a href="/pages/contact">ask us for a quote</a> or call 01744 520110.</p>';
      }
      results.innerHTML = html;
      show(true);
    }

    function get(q, signal) {
      if (cache[q]) return Promise.resolve(cache[q]);
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each';
      return fetch(url, signal ? { signal: signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) { return (cache[q] = (j.resources && j.resources.results) || {}); });
    }

    function run() {
      var raw = input.value.trim();
      unscoped = false;
      if (raw.length < 2) { show(false); results.innerHTML = ''; return; }
      var q = query();
      if (!cache[q] && !results.innerHTML) { results.innerHTML = '<p class="pcon-res__load">Searching…</p>'; show(true); }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var signal = ctrl && ctrl.signal;
      get(q, signal)
        .then(function (res) {
          if (!empty(res) || q === raw) return res;
          return get(raw, signal).then(function (res2) {
            if (!empty(res2) && input.value.trim() === raw) unscoped = true;
            return empty(res2) ? res : res2;
          });
        })
        .then(function (res) { if (input.value.trim() === raw) render(res, raw); })
        .catch(function () {});
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    form.addEventListener('submit', function (e) {
      var q = query();
      if (!q) { e.preventDefault(); return; }
      input.value = q;
    });

    /* Arrow keys move between the box and the results */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        var first = results.querySelector('a, button');
        if (first && !results.hidden) { e.preventDefault(); first.focus(); }
      }
    });
    results.addEventListener('keydown', function (e) {
      var list = [].slice.call(results.querySelectorAll('a, button'));
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < list.length - 1) { e.preventDefault(); list[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? list[i - 1] : input).focus(); }
    });
  }

  /* ---------- Mobile: fit the menu to the screen below the header ---------- */
  function initMobile() {
    var menu = document.getElementById('mobile-menu');
    var body = menu && menu.querySelector('[data-pcon-m]');
    if (!body) return;
    function isOpen() { return menu.getAttribute('aria-hidden') === 'false'; }
    /* Measured from the header's layout box, because the theme zooms the menu in
       (scale 0.9 to 1) and a transformed box reports the wrong top while it animates */
    function fit() {
      var host = menu.offsetParent;
      var top = host ? host.getBoundingClientRect().top + menu.offsetTop : menu.getBoundingClientRect().top;
      body.style.setProperty('--pcon-m-top', top + 'px');
    }
    /* The sticky header can still be settling when the menu opens, so measure again
       once it has, and whenever the page moves under it. */
    new MutationObserver(function () {
      if (!isOpen()) return;
      requestAnimationFrame(fit);
      setTimeout(fit, 120);
      setTimeout(fit, 400);
    }).observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
    window.addEventListener('resize', fit);
    window.addEventListener('scroll', function () { if (isOpen()) fit(); }, { passive: true });
    fit();
  }

  function init() {
    var nav = document.querySelector('[data-pcon]');
    if (nav) initDesktop(nav);
    [].forEach.call(document.querySelectorAll('[data-pcon-search]'), initSearch);
    initMobile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
